import clsx from "clsx";
import type { ReactNode } from "react";

interface BannerProps {
  /**
   * info: a plain notice. note: something to know that is no problem and no state, such as who is editing (the note signal).
   * warning: something went wrong or needs care (the problem signal). demo: the agent's answers are
   * recorded examples (BR-1); it has its own solid note-coloured edge, never the dashed amber of a proposal.
   */
  tone?: "info" | "note" | "warning" | "demo";
  className?: string;
  children: ReactNode;
}

/** A line across the top of a screen (the demo-mode banner, an agent notice). */
export function Banner({ tone = "info", className, children }: BannerProps) {
  return (
    <div className={clsx("banner", className)} data-tone={tone} role={tone === "warning" ? "alert" : "status"}>
      {children}
    </div>
  );
}
